"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdblockWarning = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@pulse-web-ui/icons");
const react_i18next_1 = require("react-i18next");
const i18n_1 = require("../../i18n");
const technical_screens_styles_1 = require("../../technical-screens.styles");
const AdblockWarning = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const reloadPage = () => location.reload();
    return ((0, jsx_runtime_1.jsx)(technical_screens_styles_1.Overlay, { children: (0, jsx_runtime_1.jsxs)(technical_screens_styles_1.ContentWrapper, { children: [(0, jsx_runtime_1.jsx)(technical_screens_styles_1.IconWrapper, { children: (0, jsx_runtime_1.jsx)(icons_1.Adblock, { width: 80 }) }), (0, jsx_runtime_1.jsx)(technical_screens_styles_1.Title, { children: t('SMART:Adblock.title', {
                        defaultValue: i18n_1.i18nDefaultValues.Adblock.title,
                    }) }), (0, jsx_runtime_1.jsx)(technical_screens_styles_1.Subtitle, { children: t('SMART:Adblock.subTitle', {
                        defaultValue: i18n_1.i18nDefaultValues.Adblock.subTitle,
                    }) }), (0, jsx_runtime_1.jsx)(technical_screens_styles_1.CustomButton, { label: t('SMART:Adblock.labels.update', {
                        defaultValue: i18n_1.i18nDefaultValues.Adblock.labels.update,
                    }), onClick: reloadPage })] }) }));
};
exports.AdblockWarning = AdblockWarning;
